$(document).ready(function(){
  if (!$(".infographics .infographic_slider").hasClass("slick-initialized")) {
    $('.infographics .infographic_slider').slick({        
        infinite: false,
        speed: 300,
        slidesToShow: 4, 
        slidesToScroll: 4,      
        dots: true, 
        arrows: true, 
        prevArrow: $('.infographics .prev-arrow'),
        nextArrow: $('.infographics .next-arrow'),
        appendDots: $('.infographics .slick-slider-dots'),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.4,
              slidesToScroll: 1
            }
          }          
        ]
      });
  }
  if (!$(".hempLucid-multicolumn-section .multicolumn-list").hasClass("slick-initialized")) {
    $('.hempLucid-multicolumn-section .multicolumn-list').slick({        
        infinite: false,
        speed: 300,
        slidesToShow: 4, 
        slidesToScroll: 4,      
        dots: true, 
        arrows: true, 
        prevArrow: $('.hempLucid-multicolumn-section .prev-arrow'),
        nextArrow: $('.hempLucid-multicolumn-section .next-arrow'),
        appendDots: $('.hempLucid-multicolumn-section .slick-slider-dots'),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.4,
              slidesToScroll: 1
            }
          }          
        ]
      });
  }
  if (!$(".blog__posts").hasClass("slick-initialized")) {
    $('.blog__posts').slick({        
        infinite: false,
        speed: 300,
        slidesToShow: 3, 
       slidesToScroll: 3,
        dots: true, 
        arrows: true, 
        prevArrow: $('.blog__posts_controls .prev-arrow'),
        nextArrow: $('.blog__posts_controls .next-arrow'),
        appendDots: $('.blog__posts_controls .slick-slider-dots'),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2 ,
               slidesToScroll: 2
            }
          },
          {
            breakpoint: 580,
            settings: {
              slidesToShow: 1.16,
              slidesToScroll: 1
            }
          }          
        ]
      });
   }
  /*if (!$(".blog-articles").hasClass("slick-initialized")) {
    $('.blog-articles').slick({        
        infinite: false,
        speed: 300,
        slidesToShow: 3, 
        slidesToScroll: 3,
        dots: true, 
        arrows: true, 
        prevArrow: $('.blog-slide-arrow.prev-arrow'),
        nextArrow: $('.blog-slide-arrow.next-arrow'),
        appendDots: $('.blog-slick-slider-dots'),
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1.16,
              slidesToScroll: 1
            }
          }          
        ]
      });
   }*/
  if (!$(".category_cards_slider").hasClass("slick-initialized")) {
    $('.category_cards_slider').slick({        
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true, 
        arrows: true, 
        prevArrow: $('.category_cards_controls .prev-arrow'),
        nextArrow: $('.category_cards_controls .next-arrow'),
        appendDots: $('.category_cards_controls .slick-slider-dots'),
        responsive: [
          {
            breakpoint: 1160,
            settings: {
              slidesToShow: 2,
               slidesToScroll: 2
            }
          },
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 1,
               slidesToScroll: 1
            }
          }          
        ]
      });
   }
  if (!$(".star_reviews_slider").hasClass("slick-initialized")) {
    $('.star_reviews_slider').slick({        
        infinite: false,
        speed: 300,
        slidesToShow: 3,
       slidesToScroll: 3,
        dots: true, 
        arrows: true, 
        prevArrow: $('.star_reviews_controls .prev-arrow'),
        nextArrow: $('.star_reviews_controls .next-arrow'),
        appendDots: $('.star_reviews_controls .slick-slider-dots'),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
               slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
               slidesToScroll: 1
            }
          }          
        ]
      });
   }
  if (!$(".hempLucid_lovers_slider").hasClass("slick-initialized")) {
    $('.hempLucid_lovers_slider').slick({        
        infinite: false,
        speed: 300,
        slidesToShow: 4,   
        slidesToScroll: 4,
        dots: true, 
        arrows: true, 
        prevArrow: $('.hempLucid_lovers_controls .prev-arrow'),
        nextArrow: $('.hempLucid_lovers_controls .next-arrow'),
        appendDots: $('.hempLucid_lovers_controls .slick-slider-dots'),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3, 
               slidesToScroll: 3
            }
          },
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 2,
               slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
               slidesToScroll: 1
            }
          }          
        ]
      });
   }
  if (!$(".experts_say_section.experts-say .multicolumn-list").hasClass("slick-initialized")) {
    $('.experts_say_section.experts-say .multicolumn-list').slick({        
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,    
        dots: true, 
        arrows: true, 
        prevArrow: $('.experts_say_controls.experts-say_controls .prev-arrow'),
        nextArrow: $('.experts_say_controls.experts-say_controls .next-arrow'),
        appendDots: $('.experts_say_controls.experts-say_controls .slick-slider-dots'),
        responsive: [         
          {
            breakpoint: 989,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,  
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }          
        ]
      });
  }
  if (!$(".experts_say_section.icon-cards .multicolumn-list").hasClass("slick-initialized")) {
    $('.experts_say_section.icon-cards .multicolumn-list').slick({        
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,    
        dots: true, 
        arrows: true, 
        prevArrow: $('.experts_say_controls.icon-cards_controls .prev-arrow'),
        nextArrow: $('.experts_say_controls.icon-cards_controls .next-arrow'),
        appendDots: $('.experts_say_controls.icon-cards_controls .slick-slider-dots'),
        responsive: [         
          {
            breakpoint: 989,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,  
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.4,
              slidesToScroll: 1
            }
          }          
        ]
      });
  }
  if (!$(".mushroom_products_section .multicolumn-list").hasClass("slick-initialized")) {
    $('.mushroom_products_section .multicolumn-list').slick({        
        infinite: false,
        speed: 300,
        slidesToShow: 3,   
       slidesToScroll: 3,
        dots: true, 
        arrows: true, 
        prevArrow: $('.mushroom_products_controls .prev-arrow'),
        nextArrow: $('.mushroom_products_controls .next-arrow'),
        appendDots: $('.mushroom_products_controls .slick-slider-dots'),
        responsive: [         
          {
            breakpoint: 989,
            settings: {
              slidesToShow: 2,
               slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
               slidesToScroll: 1,
              centerMode: true,
              infinite: true,
            }
          }          
        ]
      });
  } 
  if (!$(".related-products .product-grid").hasClass("slick-initialized")) {
    $('.related-products .product-grid').slick({        
        infinite: false,
        speed: 300,
        slidesToShow: 4,  
       slidesToScroll: 4,
        dots: true, 
        arrows: true, 
        prevArrow: $('.products_controls .prev-arrow'),
        nextArrow: $('.products_controls .next-arrow'),
        appendDots: $('.products_controls .slick-slider-dots'),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3, 
               slidesToScroll: 3
            }
          },
          {
            breakpoint: 989,
            settings: {
              slidesToShow: 2,
               slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
               slidesToScroll: 2
            }
          }          
        ]
      }); 

      if($('.related-products .grid.product-grid .grid__item').length == 0){
        $('.related-products').hide();
      }else{
         $('.related-products').show();
      }
    } 
  if (!$(".main-slider").hasClass("slick-initialized")) {
    $('.main-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,  
      dots:true,
      infinite:false,
      focusOnSelect: true, 
      asNavFor: '.nav-slider'  
    });
  }
  if (!$(".nav-slider").hasClass("slick-initialized")) {
    $('.nav-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      draggable:true,
      focusOnSelect: true,  
      arrows: false,
      infinite:false,  
      asNavFor: '.main-slider',  
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3   
          }
        }  
        ]
    });  
  }
  if (!$(".iwtc_slider").hasClass("slick-initialized")) {
    $('.iwtc_slider').slick({        
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true, 
        arrows: true, 
        prevArrow: $('.iwtc_controls .prev-arrow'),
        nextArrow: $('.iwtc_controls .next-arrow'),
        appendDots: $('.iwtc_controls .slick-slider-dots'),
        responsive: [
          {
            breakpoint: 1279,
            settings: {
              slidesToShow: 3,
               slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.1,
               slidesToScroll: 1
            }
          }          
        ]
      });
   }

  
  // if (!$(".not-empty-cart .cart--bestsellers-products").hasClass("slick-initialized")) {
  //   $('.not-empty-cart .all_product .cart--bestsellers-products').slick({
  //                     slidesToShow: 1,
  //                     slidesToScroll: 1,
  //                     arrows: true,
  //                     dots: false,
  //                     infinite: true
  //               });
  //   }

  if (!$(".cart-bundlesave-slider").hasClass("slick-initialized")) {
     $('.cart-bundlesave-slider').slick({
        infinite: false,
        speed: 300,
        slidesToShow: 1,  
        slidesToScroll:1,
        dots: true, 
        arrows: true, 
        prevArrow: $('.cart_bestsellers_controls .prev-arrow'),
        nextArrow: $('.cart_bestsellers_controls .next-arrow'),
        appendDots: $('.cart_bestsellers_controls .slick-slider-dots'),
       });
  } 
  
  if (!$(".cart--gifts-products").hasClass("slick-initialized")) {
     $('.cart--gifts-products').slick({
        infinite: false,
        speed: 300,
        slidesToShow: 1,  
        slidesToScroll:1,
        dots: true, 
        arrows: true, 
        prevArrow: $('.cart_gifts_controls .prev-arrow'),
        nextArrow: $('.cart_gifts_controls .next-arrow'),
        appendDots: $('.cart_gifts_controls .slick-slider-dots'),
       });
  } 
  
// });

// $(document).ready(function(){  
  
    $('.footer__blocks-wrapper h2.footer-block__heading').on('click',function(){
        if($(this).hasClass('open')){
            $('.footer__blocks-wrapper h2.footer-block__heading').removeClass('open');
        }else{
          $('.footer__blocks-wrapper h2.footer-block__heading').removeClass('open');
          $(this).addClass('open');
        }
      });     
    $(".tab_content").hide();
    $(".tab_content:first").show();  
    $("ul.tabs li").click(function() {		
      $(".tab_content").hide();
      var activeTab = $(this).attr("rel"); 
      $("#"+activeTab).fadeIn();
      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");	  
    });
    $('.experts_say_section .multicolumn-card__info .link').click(function() {     
    if($(this).prev().hasClass('open')){
        $('.experts_say_section .rte').removeClass('open');
        $(this).text('read more');
    }else{
      $('.experts_say_section .rte').removeClass('open');
      $(this).prev().addClass('open');
      $('.experts_say_section .multicolumn-card__info .link').text('read more');
      $(this).text('read less');
    }
    });	

 var subsavePrice = $('.product__info-container [name="id"]').find('option:selected').attr('data-subscription-price');
$('#subsave').attr('data-price', subsavePrice);
    
    $(".product-quantity-select").on("change",function(){    
      $(".form-hidden-qty-num").val($(this).val());            
      // if($(this).parents('.shopify-product-form').find('.subsave-plan').hasClass('option-button-selected')){
      //   var dprice = $(this).parents('.shopify-product-form').find('[name="id"] option[selected]').attr('data-subscription-price');
      // }else{
      //   var dprice = $(this).parents('.shopify-product-form').find('[name="id"] option[selected]').attr('data-onetime-price');
      // }
var dprice = $(this).parents('.product__info-wrapper').find('.selectable-subscription .option-button-selected').attr('data-price');
      
console.log(dprice)
      let qty = parseInt($(this).val()),     
      calcPrice = dprice * qty,
      discountPrice = (calcPrice/100).toFixed(2);    
      $(this).parents('.shopify-product-form').find('span.final-price').text('$'+discountPrice);         
      $('button.sticky_atc_btn.button span.final-price').text('$'+discountPrice);      
      let onetimePrice = $(this).parents('.shopify-product-form').find('[name="id"] option[selected]').attr('data-onetime-price');
      onetimePrice = onetimePrice * qty,
      onetimePrice = (onetimePrice/100).toFixed(2); 
      $(this).parents('.shopify-product-form').find('.onetimePrice').text('$'+onetimePrice);
      $(this).parents('.shopify-product-form').find('#onetimePrice').text('$'+onetimePrice);      
      let subsavePrice = $(this).parents('.shopify-product-form').find('[name="id"] option[selected]').attr('data-subscription-price');
      subsavePrice = subsavePrice * qty,
      subsavePrice = (subsavePrice/100).toFixed(2);   
      $(this).parents('.shopify-product-form').find('.subsavePrice').text('$'+subsavePrice); 
      $(this).parents('.shopify-product-form').find('#subsavePrice').text('$'+subsavePrice);       
      let sezzleprice = $(this).parents('.shopify-product-form').find('[name="id"] option[selected]').attr('data-sezzle-price');
      sezzleprice = sezzleprice * qty,
      sezzleprice = (sezzleprice/100).toFixed(2);    
      $(this).parents('.shopify-product-form').find('#sezzleProductPrice').text('$'+sezzleprice+' USD');        
      if( $('.quickview_modal').hasClass('active')){
        let dprice2 = $('.quickview_modal.active').data('price').replace('$',''),
        calcPrice2 = dprice2 * qty,
        discountPrice2 = calcPrice2.toFixed(2);    
        $('.quickview_modal.active  .quickview_product_info .product-item__quick-form .button span, .quickview_modal.active  .quickview_product_form .product-item__quick-form .button span').text('$'+discountPrice2);
     }      

      $("product-info .option-selector-wrapper .option-button-selected").click();
    });
  
    setTimeout(function() {  
      $('.not-empty-cart .all_product .cart--bestsellers-products').slick('setPosition'); 
    }, 1000);
  
    setTimeout(function() {  
      $('.not-empty-cart .all_product .cart--bestsellers-products').slick('setPosition'); 
    }, 300);
   $("cart-drawer").bind("DOMSubtreeModified", function() {     
          // if (!$(".not-empty-cart .all_product .cart--bestsellers-products").hasClass("slick-initialized")) {
          //     $('.not-empty-cart .all_product .cart--bestsellers-products').slick({
          //             slidesToShow: 1,
          //             slidesToScroll: 1,
          //             arrows: true,
          //             dots: false,
          //             infinite: true
          //       });
          //   }     
     
if (!$(".cart-bundlesave-slider").hasClass("slick-initialized")) {
     $('.cart-bundlesave-slider').slick({
        infinite: false,
        speed: 300,
        slidesToShow: 1,  
        slidesToScroll:1,
        dots: true, 
        arrows: true, 
        prevArrow: $('.cart_bestsellers_controls .prev-arrow'),
        nextArrow: $('.cart_bestsellers_controls .next-arrow'),
        appendDots: $('.cart_bestsellers_controls .slick-slider-dots'),
       });
  }
      if (!$(".cart--gifts-products").hasClass("slick-initialized")) {
     $('.cart--gifts-products').slick({
        infinite: false,
        speed: 300,
        slidesToShow: 1,  
        slidesToScroll:1,
        dots: true, 
        arrows: true, 
        prevArrow: $('.cart_gifts_controls .prev-arrow'),
        nextArrow: $('.cart_gifts_controls .next-arrow'),
        appendDots: $('.cart_gifts_controls .slick-slider-dots'),
       });
  }
     
    });  
    $(document).on('click','.header__icon--cart,.quick-addToCart,#addToCart', function(e) {  
      
      setTimeout(function(){      
        $('.not-empty-cart .all_product .cart--bestsellers-products').slick('setPosition');
        },200);
    });    
    $(document).on('click','.cart-remove-button', function(e) {
       $('.not-empty-cart .all_product .cart--bestsellers-products').slick('setPosition');      
    });
    $(document).on('click','.quickview_btn', function(e) {
      var d_modal = $(this).attr('data-modal');
      $('#'+d_modal).show();
      $('body').addClass('model_open');
    });    
    $(document).on('click','.quickview_close', function(e) {      
      $('.quickview_modal').hide();
      $('body').removeClass('model_open');
    });   
    $(document).on('change','.quickview_variants input[type="radio"]', function(e) {     
      var d_img = $(this).attr('data-image'),val = $(this).val(),id = $(this).attr('data-id');
      $(this).parents('.quickview_product_row').children('.quickview_product_image').children('img').attr('src',d_img);
      $(this).parents('.quickview_product_row').children('.quickview_product_image').children('img').attr('srcset',d_img);
      $(this).parents('.quickview__options').find('.color_name').text(val);
     $(this).parents('.quickview__options').next().find('input[name="id"]').val(id);
     setTimeout(function(){
       $('cart-drawer').attr('open',true);
     }, 5);     
    });
    $(document).on('click','.quickview_product_info .product-item__quick-form button[type=submit]', function(e) {
       $('.quickview_modal').hide();
       $('body').removeClass('model_open');
    });  
    setInterval(function () {
      if( $('.yotpo.yotpo-main-widget .yotpo_customer_title').length == 0 ){
         $('.yotpo.yotpo-main-widget .main-widget').before('<h2 class="yotpo_customer_title">Customer Reviews</h2>');
      }
    }, 1000);
    $(document).on('click','.quickview_btn.desktop_show, .cart-bundle-modal a.view_product_details , .cart-bundle-modal .product-item__quick-form .button', function(e) {     
      $('cart-drawer .drawer__close').click();
      $('.quickview_modal').hide();
      var d_modal = $(this).attr('data-modal');
      $('#'+d_modal).show();
      $('#'+d_modal).addClass('active');
      $('body').addClass('model_open');     
      $('#'+d_modal).find('.option-selector-wrapper ul').each(function () {       
       if($(this).children('li.option-button-selected').length == 0 ){
         $('#'+d_modal).find('.option-selector-wrapper ul li.button-label:first-child').addClass('option-button-selected'); 
         $('#'+d_modal).find('[name="id"] option').prop('selected',false);
         $('#'+d_modal).find('[name="id"] option:first-child').prop('selected',true);
       }
     });       
    });
    $(document).on('click','.gift_quickview_btn', function(e) {     
      $('cart-drawer .drawer__close').click();
      var d_modal = $(this).attr('data-modal');
      $('#'+d_modal).show();
      $('#'+d_modal).addClass('active'); 
      $('.cart-gift-collection,.cart-gift-collection-overlay').hide();        
    }); 
    $(document).on('click','.quickview_close', function(e) {     
     e.preventDefault();    
      $('.quickview_modal').hide(); 
      $('.quickview_modal').removeClass('active');
      $('body').removeClass('model_open');
      $('cart-drawer').attr('open',true); 
      $('.cart-gift-collection,.cart-gift-collection-overlay').show();    
      setTimeout(function(){
       $('cart-drawer').attr('open',true);
     }, 5);
    }); 
    $(document).on('click','.cart_drawer_footer_totals p.total__title', function(e) {
      e.preventDefault();     
      $(this).toggleClass('open');
      $('.cart_drawer_footer_dropdown').toggleClass('show');
    });    
    $(document).on('click','.cart-gift-collection-close', function(e) {
      e.preventDefault();          
      $('.cart-gift-collection,.cart-gift-collection-overlay').hide();
    }); 
    /*  
    $(document).on('click','.product .five_star_review_section .button', function(e) {
        e.preventDefault(); 
        console.log("width offset: "+$('.yotpo-main-widget').offset().top+', header outerheight: '+$('header').outerHeight());
      
        $('html,body').animate({ scrollTop: $('.yotpo-main-widget').offset().top - $('header').outerHeight() }, 500);
        return false;  
    });
    */

  /*** Cart Subscribe click ***/
  $(document).on('click','.cart-subscription-top.otp', function(e) {    
     let classList = $(e.target).attr('class');
    console.log('subscribe checkbox clicked');
     if (classList != null) {
       console.log('ClassList != Null');
       var $cartItem = $(this).parents(".cart-item");
        $cartItem.addClass("remove");
       var $cartItem = $(this).parents(".cart-item.remove");     
       var drawervar = parseInt($(this).attr("data-cart-var"));   
       var drawervarline = $cartItem.attr("data-line-attr"); 
      var quantityval = $(this).parents(".cart-item").find('.cart-quantity .quantity__input').val();
       var data= '';
        if($(this).parents('.cart-item').hasClass('bundleandsave-item')){
          data = {quantity: quantityval, id: drawervar,properties: { 'Bundle & Save 10%': 'true' } };
        }else{
           data = { quantity: quantityval, id: drawervar}  ;
        }

       console.log('Data: '+ data);
        $.ajax({
          url: "/cart/change.js",
          type: "post",
           dataType:'json',
           data:  { quantity: 0, line:drawervarline},
          success: function(cart){
          $.ajax({
            url: "/cart/add.js",
            type: "post",
            dataType: 'json',
            data: data,
            success: function(cart) {            
                $("cart-drawer").load(location.href + " cart-drawer>*","");
               $("a.header__icon--cart").load(location.href + " a.header__icon--cart>*","");            
            }
        });
       },
       error: function(err){
       }
      });    
     } else {
       return;
     }
  });  
   $(document).on('click','.cart-subscription-top.save', function(e) {
    let classList = $(e.target).attr('class');
    console.log(classList);
    if (classList != null) {
      console.log("Save classList != null");
       var $cartItem = $(this).parents(".cart-item");
        $cartItem.addClass("remove");
       var $cartItem = $(this).parents(".cart-item.remove");
       var drawersub = parseInt($(this).attr("data-cart-sub"));
       var drawervar = parseInt($(this).attr("data-cart-var"));   
       var drawervarline = $cartItem.attr("data-line-attr");  
      var quantityval = $(this).parents(".cart-item").find('.cart-quantity .quantity__input').val();
       var data= '';
        if($(this).parents('.cart-item').hasClass('bundleandsave-item')){
          data = {quantity: quantityval, id: drawervar,selling_plan: drawersub,properties: { 'Bundle & Save 10%': 'true' , 'Subscription Discount': 'Subscription Discount' } };
        }else{
           data = { quantity: quantityval, id: drawervar, selling_plan: drawersub, properties: { 'Subscription Discount': 'Subscription Discount' }  } ;
        }
      
        console.log('quantity: '+quantityval+', id: '+drawervar+', selling_plan: '+drawersub);
        $.ajax({
          url: "/cart/change.js",
          type: "post",
           dataType:'json',
           data:  { quantity: 0, line:drawervarline},
          success: function(cart){
          $.ajax({
            url: "/cart/add.js",
            type: "post",
            dataType: 'json',
            data: data,
            success: function(cart) {
                
                $("cart-drawer").load(location.href + " cart-drawer>*","");
                $("a.header__icon--cart").load(location.href + " a.header__icon--cart>*","");  
              
            }
        });
        },
          error: function(err){
        }
      }); 
    } else {
       return;
    }
  });  
   $(document).on('click','.quickview_product_info .product-item__quick-form .button, .quickview_product_form .product-item__quick-form .button', function(e) {
      e.preventDefault();
      e.stopPropagation();    
      var qty = parseInt($('.form-hidden-qty-num').val()) ,id =  $(this).parent('.product-item__quick-form').find('input[name="id"]').val();  
      $.ajax({
        url: "/cart/add.js",
        type: "post",
        dataType:'json',
        data: {quantity:qty,id:id},
        success: function(cart){ 
          $(".header__icon--cart").load(location.href + "  .header__icon--cart>*","");
          $("#CartDrawer").load(location.href + "  #CartDrawer>*","");
          $('cart-drawer').addClass('active');
          setTimeout(function() {
              $('.not-empty-cart .all_product .cart--bestsellers-products').slick('setPosition'); 
          }, 300); 
          $('.gift-quickview-popup .quickview_modal').removeClass('active');
        },
        error: function(){
          console.log('error');	
        }
      });
    });
   $(document).on('click','.quick__add__submit,.product_quick_btn', function(e) {    
      var d_modal = $(this).attr('data-modal');
      $(d_modal).show();
      $(d_modal).addClass('active');
      $('body').addClass('model_open');    
     $(d_modal).find('.option-selector-wrapper ul').each(function () {       
       if($(this).children('li.option-button-selected').length == 0 ){
         $(d_modal).find('.option-selector-wrapper ul li.button-label:first-child').addClass('option-button-selected'); 
         $(d_modal).find('[name="id"] option').prop('selected',false);
         $(d_modal).find('[name="id"] option:first-child').prop('selected',true);
       }
     });        
    });    
  $('.subsave-plan').on('click', function(){      
    //$(this).parent().find('.q_sellingPlan').val('subsave');
    $(this).parent().find('.selectable-subscription').show();
    $(this).parents('.shopify-product-form').find('.onetime-subscribe').removeClass('option-button-selected');
    $(this).addClass('option-button-selected');
    let q_qty = parseInt($(this).parents('.shopify-product-form').find('.form-hidden-qty-num').val());
    let q_s_price = $(this).parents('.shopify-product-form').find('[name="id"] option[selected]').attr('data-subscription-price');
    q_s_price = q_s_price * q_qty;
    q_s_price = (q_s_price/100).toFixed(2);
    $(this).parents('.shopify-product-form').find('span.final-price').text('$' + q_s_price);
    // $('.sticky_atc_btn').find('span.final-price').text('$' + q_s_price);
    $(this).parents('.shopify-product-form').find('.subsavePrice').text('$'+q_s_price);    
   // $(this).parents('.shopify-product-form').find('.subscription-selector:first-child').addClass('option-button-selected');
  });
  //One-Time Purchase Selector Clicked
  $('.onetime-plan').on('click', function() {
    $(this).parent().find('.q_sellingPlan').val(null);
   // $(this).parent().find('.selectable-subscription').hide(); 
    $(this).parents('.shopify-product-form').find('.onetime-subscribe').removeClass('option-button-selected');
    $(this).parents('.shopify-product-form').find('.subscription-selector').removeClass('option-button-selected');
    $(this).addClass('option-button-selected');    
     let q_qty = parseInt($(this).parents('.shopify-product-form').find('.form-hidden-qty-num').val());
     let q_s_price = $(this).parents('.shopify-product-form').find('[name="id"] option[selected]').attr('data-onetime-price');
     q_s_price = q_s_price * q_qty;
     q_s_price = (q_s_price/100).toFixed(2);
     $(this).parents('.shopify-product-form').find('span.final-price').text('$' + q_s_price);
    // $('.sticky_atc_btn').find('span.final-price').text('$' + q_s_price);
     $(this).find('.onetimePrice').text('$'+q_s_price);    
  });
  //Subscription Plan Selector Clicked (2 weeks, etc)
  $('.subscription-selector').on('click', function(e) {   
   
    var sellingPlanId = $(this).attr('data-selling-plan-id');
    $(this).parent().next('.q_sellingPlan').val(sellingPlanId);
    $(this).parents('.shopify-product-form').find('.subscription-selector').removeClass('option-button-selected');
    $(this).addClass('option-button-selected');
    console.log('Selling plan id: '+sellingPlanId);   
    $(this).parents('.selectable-subscription').find('.subscriptionOptions_arrow span').html($(this).parents('.shopify-product-form').find('.subscription-selector.option-button-selected').html());
    $(this).parents('.selectable-subscription').find(".subscriptionOptions_arrow").removeClass("active-size-variant");
    $(this).parent(".subscriptionOptions_dropdown").slideUp();     
     let q_qty = parseInt($(this).parents('.shopify-product-form').find('.form-hidden-qty-num').val());
     let q_s_price = $(this).parents('.shopify-product-form').find('[name="id"] option[selected]').attr('data-subscription-price');
     q_s_price = q_s_price * q_qty;
     q_s_price = (q_s_price/100).toFixed(2);
     $(this).parents('.shopify-product-form').find('span.final-price').text('$' + q_s_price);
    // $('.sticky_atc_btn').find('span.final-price').text('$' + q_s_price);
     $(this).parents('.shopify-product-form').find('.subsavePrice').text('$'+q_s_price);
  });    
    $(".related-products-modal .subscriptionOptions_arrow").on("click",function(){
    $(this).next().slideToggle();
    $(this).toggleClass("active-size-variant");
  });
  $('.tooltip svg').mouseenter(function(){
      $(this).parent().next('.subscriptionTooltip').fadeIn();
    })
    .mouseleave(function(){
      $('.subscriptionTooltip').fadeOut();
    }); 

  $(document).on('mouseover', '.cart_tooltip', function() {
    $(this).next('.cart_subscriptionTooltip').fadeIn();
    console.log('Fading in');
  });
  
  $(document).on('mouseleave', '.cart_tooltip', function() {
    $('.cart_subscriptionTooltip').fadeOut();
    console.log('Fading Out');
  });
  
  $(document).on('click', function (event) {
    if (!$(event.target).closest('#subscriptionOptions').length) {
      if($(".subscriptionOptions_arrow").hasClass("active-size-variant")){
        $(".subscriptionOptions_arrow").removeClass("active-size-variant");
        $(".subscriptionOptions_dropdown").slideUp();
      }
    }
  });
  if($('.product_atc_sticky').length > 0){    
  $(window).on('load resize scroll ', function() {
      if ($('.product__info-wrapper  #pdpFormActions #formBtns button').isInViewport()) {
          $('.product_atc_sticky').addClass('hide');
      } else {
          $('.product_atc_sticky').removeClass('hide');
          if(!$('.product_atc_sticky').hasClass('hide')){
             $('.sticky_atc_btn').find('span.final-price').text('');
            $('.sticky_atc_btn').find('span.final-price').text($('product-info .formBtns_price.button span.final-price').text());
            // alert($('.formBtns_price.button span').text());
          } 
      }
  });
   $(document).on('click','.sticky_atc_btn',function() {    
    $('html, body').animate({
        scrollTop: $('.product__info-wrapper  #pdpFormActions #formBtns button').offset().top - 400
    }, 50);
  });
    $.fn.isInViewport = function() {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    };
 }
  $(document).on('click','.free-gift-popup', function(e) {
    $('.cart-gift-collection-overlay,.cart-gift-collection').removeClass('hidden'); 
    $('.cart-gift-collection-overlay,.cart-gift-collection').css('display','block'); 
    $('.not-empty-cart .all_product .cart--bestsellers-products').slick('setPosition');
  });
  $(document).on('click','.free-addToCart.button', function(e) {
      e.preventDefault();
      e.stopPropagation();    
      var vid =  $(this).parents('.shopify-product-form').find('.quick-productSelect option:selected').val();  
    if($('.cart-item.free-gift-item').length > 0){
     $.ajax({
      url: "/cart/change.js",
      type: "post",
       dataType:'json',
       data:  { quantity: 0, id:$('.cart-item.free-gift-item').data('id')},
      success: function(cart){      
      $.ajax({
        url: "/cart/add.js",
        type: "post",
        dataType: 'json',
        data:  { quantity: 1, id:vid,properties: { 'Product': 'Free Gift' } },  
        success: function(cart) {            
           $(".header__icon--cart").load(location.href + "  .header__icon--cart>*","");
          $("#CartDrawer").load(location.href + "  #CartDrawer>*","");
          $('cart-drawer').addClass('active');              
          $('.gift-products-modal .quickview_modal').removeClass('active'); 
          $('.gift-products-modal .quickview_modal').hide();   
          setTimeout(function() {
              $('.drawer .cart-drawer .cart--bestsellers.cart-gift-collection,div.cart-gift-collection-overlay').hide(); 
          }, 300);           
        }
    });
              },
      error: function(err){
      }
      }); 
    }  else{     
      $.ajax({
        url: "/cart/add.js",
        type: "post",
        dataType:'json',
        data:  { quantity: 1, id:vid,properties: { 'Product': 'Free Gift' } },    
        success: function(cart){           
          $(".header__icon--cart").load(location.href + "  .header__icon--cart>*","");
          $("#CartDrawer").load(location.href + "  #CartDrawer>*","");
          $('cart-drawer').addClass('active');              
          $('.gift-products-modal .quickview_modal').removeClass('active'); 
          $('.gift-products-modal .quickview_modal').hide();   
          setTimeout(function() {
              $('.drawer .cart-drawer .cart--bestsellers.cart-gift-collection,div.cart-gift-collection-overlay').hide(); 
          }, 300);
        },
        error: function(){
          console.log('error');	
        }
      });
      }
    });   
  function freegiftfunction(){
  $(".all-gifts-list .svg-with-id").each(function(){
       if($(this).find(".checkmark-icon").css("opacity") == "0") {        
         $(this).removeClass("active-value-js")          
       }
       else{
         $(this).addClass("active-value-js")         
       }
     });
  if(!$('.product-1-gift').hasClass('active-value-js')){     
    setTimeout(function(){    
     $.ajax({
      url: "/cart/change.js",
      type: "post",
      dataType:'json',
      async: false,
      data:  { quantity: 0, id:$('.cart-item.free-gift-item').data('id') },
      success: function(cart){
         $(".header__icon--cart").load(location.href + "  .header__icon--cart>*","");
         $("#CartDrawer").load(location.href + "  #CartDrawer>*","");         
     },
      error: function(err){     
      }
      }); 
           },100);
  }
  }
  freegiftfunction();
   $(document).on('click','.cart-remove-button', function(e) {
       $('.not-empty-cart .all_product .cart--bestsellers-products').slick('setPosition');
       setTimeout(function(){
          freegiftfunction();
          var api = new Yotpo.API(yotpo);
          api.refreshWidgets();
       },1000); 
       setTimeout(function(){
          freegiftfunction();
          var api = new Yotpo.API(yotpo);
          api.refreshWidgets();
       },2500);
    });

  $(document).on('click','.quantity__button',function () {
     setTimeout(function(){
          freegiftfunction();
          var api = new Yotpo.API(yotpo);
          api.refreshWidgets();
       },1000);    
      setTimeout(function(){
          freegiftfunction();
          var api = new Yotpo.API(yotpo);
          api.refreshWidgets();
       },2500);
  });
  $(document).on('click','.cart_subscriptionOptions_arrow', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).next().slideToggle();
    $(this).toggleClass("active-size-variant");
  });     
  $(document).on('click', function (event) {
    if (!$(event.target).closest('#cartsubscriptionOptions').length) {
      if($(".cart_subscriptionOptions_arrow").hasClass("active-size-variant")){
        $(".cart_subscriptionOptions_arrow").removeClass("active-size-variant");
        $(".cart_subscriptionOptions_dropdown").slideUp();
      }
    }
  }); 
 // if($('li.cart-button-label').length>0){
    $(document).on('click','li.cart-button-label', function(e) {
      e.preventDefault();     
      var c_sellingPlanId = $(this).attr('data-selling-plan-id');
      var $cartItem = $(this).parents(".cart-item");
      $cartItem.addClass("remove");
      var $cartItem = $(this).parents(".cart-item.remove");     
      var drawervar = parseInt($cartItem.attr("data-cart-var"));   
      var drawervarline = $cartItem.attr("data-line-attr");    
      var quantityval = $(this).parents(".cart-item").find('.cart-quantity .quantity__input').val();
      $('li.cart-button-label.cart-subscription-selector').removeClass('cart-option-button-selected');
      $(this).addClass('cart-option-button-selected');
      $(".cart_subscriptionOptions_arrow").removeClass("active-size-variant");
     $(".cart_subscriptionOptions_dropdown").slideUp();     
      var data= '';
      if($(this).parents('.cart-item').hasClass('bundleandsave-item')){
        data = {quantity: 1, id: drawervar, selling_plan: c_sellingPlanId ,properties: { 'Bundle & Save 10%': 'true' } };
      }else{
         data = { quantity: quantityval, id: drawervar, selling_plan: c_sellingPlanId}  ;
      }
    $.ajax({
      url: "/cart/change.js",
      type: "post",
       dataType:'json',
       data:  { quantity: 0, line:drawervarline},
      success: function(cart){      
      $.ajax({
        url: "/cart/add.js",
        type: "post",
        dataType: 'json',
        data: data,
        success: function(cart) {            
            $("cart-drawer").load(location.href + " cart-drawer>*","");
            $("a.header__icon--cart").load(location.href + " a.header__icon--cart>*","");            
        }
    });
              },
      error: function(err){
      }
      }); 
    });
 // }
$(document).on('click', '.bundle-title', function(e) {
    $(this).toggleClass('bundle_open'); // Add your class name here
    $(this).parent('.cart--bundle').find('.all_product').slideToggle();
    $('.cart-bundlesave-slider').slick('setPosition'); 
});

});